import React from 'react';

const parseInline = (text) => {
  const withLinks = String(text).split(/(\[[^\]]+\]\((?:https?:\/\/)[^)]+\))/g);

  const nodes = [];
  withLinks.forEach((chunk, i) => {
    const linkMatch = chunk.match(/^\[([^\]]+)\]\(((?:https?:\/\/)[^)]+)\)$/);
    if (linkMatch) {
      nodes.push(
        <a key={`l-${i}`} href={linkMatch[2]} target="_blank" rel="noreferrer">
          {linkMatch[1]}
        </a>
      );
      return;
    }

    const codeParts = chunk.split(/(`[^`]+`)/g);
    codeParts.forEach((codeChunk, j) => {
      if (!codeChunk) return;
      if (/^`[^`]+`$/.test(codeChunk)) {
        nodes.push(<code key={`c-${i}-${j}`}>{codeChunk.slice(1, -1)}</code>);
        return;
      }

      const boldParts = codeChunk.split(/(\*\*[^*]+\*\*|__[^_]+__)/g);
      boldParts.forEach((boldChunk, k) => {
        if (!boldChunk) return;
        if (/^\*\*[^*]+\*\*$/.test(boldChunk)) {
          nodes.push(<strong key={`b-${i}-${j}-${k}`}>{boldChunk.slice(2, -2)}</strong>);
          return;
        }
        if (/^__[^_]+__$/.test(boldChunk)) {
          nodes.push(<strong key={`b2-${i}-${j}-${k}`}>{boldChunk.slice(2, -2)}</strong>);
          return;
        }

        const italicParts = boldChunk.split(/(\*[^*]+\*|_[^_]+_)/g);
        italicParts.forEach((italicChunk, m) => {
          if (!italicChunk) return;
          if (/^\*[^*]+\*$/.test(italicChunk)) {
            nodes.push(<em key={`i-${i}-${j}-${k}-${m}`}>{italicChunk.slice(1, -1)}</em>);
            return;
          }
          if (/^_[^_]+_$/.test(italicChunk)) {
            nodes.push(<em key={`i2-${i}-${j}-${k}-${m}`}>{italicChunk.slice(1, -1)}</em>);
            return;
          }
          nodes.push(<React.Fragment key={`t-${i}-${j}-${k}-${m}`}>{italicChunk}</React.Fragment>);
        });
      });
    });
  });

  return nodes;
};

const SimpleMarkdown = ({ text, className }) => {
  return <span className={className}>{parseInline(text)}</span>;
};

export default SimpleMarkdown;

